import script from "./RefundReply.vue?vue&type=script&setup=true&lang=js"
export * from "./RefundReply.vue?vue&type=script&setup=true&lang=js"

import "./RefundReply.vue?vue&type=style&index=0&id=b06889fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b06889fe"]])

export default __exports__